import { useState, useEffect } from "react";
import { userServiceApi } from "@shared/api";

interface UseUserInfoResult {
  userInfo: any | null;
  isLoading: boolean;
  error: string | null;
}

export const useUserInfo = (userId?: string): UseUserInfoResult => {
  const [userInfo, setUserInfo] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userId) {
      setUserInfo(null);
      return;
    }

    const fetchUser = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await userServiceApi.get(
          `/api/v1/users/${userId}/contacts`,
        );
        setUserInfo(response.data);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "Ошибка загрузки пользователя",
        );
        setUserInfo(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [userId]);

  return { userInfo, isLoading, error };
};
